import React from 'react';
import { Button, Box, IconButton, Typography } from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useParams, useNavigate } from 'react-router-dom';

const Report2 = () => {
  const { reportId } = useParams();
  const navigate = useNavigate();
  
  const sampleReports = [
    {
      id: 1,
      title: "FRAX Report - Goldberry River-Daughter",
      patientName: "Goldberry River-Daughter",
    },
    {
      id: 2,
      title: "CAROC Report - Aragorn Son of Arathorn",
      patientName: "Aragorn Son of Arathorn",
    },
    {
      id: 3,
      title: "FRAX Report - Bilbette Baggins",
      patientName: "Bilbette Baggins",
    }
  ];
  
  const currentReport = sampleReports.find(r => r.id === parseInt(reportId)) || sampleReports[0];
  const currentIndex = sampleReports.findIndex(r => r.id === parseInt(reportId));
  
  const goToPreviousReport = () => {
    if (currentIndex > 0) {
      navigate(`/report/${sampleReports[currentIndex - 1].id}`);
    }
  };
  
  const goToNextReport = () => {
    if (currentIndex < sampleReports.length - 1) {
      navigate(`/report/${sampleReports[currentIndex + 1].id}`);
    }
  };
  
  return (
    <div style={{
      fontFamily: 'Arial, sans-serif',
      lineHeight: '1.4',
      margin: 0,
      padding: '20px',
      backgroundColor: '#ffffff',
      color: '#333',
      display: 'flex',
      justifyContent: 'center',
      '@media print': {
        padding: 0,
      },
    }}>
      <Box style={{
        maxWidth: '8.5in',
        width: '100%',
        backgroundColor: '#ffffff',
      }}>
        <Box style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          marginBottom: '20px',
          '@media print': {
            display: 'none',
          },
        }}>
          <Box style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <IconButton
              onClick={goToPreviousReport}
              disabled={currentIndex === 0}
              style={{ color: currentIndex === 0 ? '#ccc' : '#0a3d62' }}
            >
              <NavigateBeforeIcon />
            </IconButton>
            <Typography variant="body2" style={{ color: '#666' }}>
              {currentReport.title}
            </Typography>
            <IconButton
              onClick={goToNextReport}
              disabled={currentIndex === sampleReports.length - 1}
              style={{ color: currentIndex === sampleReports.length - 1 ? '#ccc' : '#0a3d62' }}
            >
              <NavigateNextIcon />
            </IconButton>
          </Box>
          
          <Box style={{ display: 'flex', gap: '10px' }}>
            <Button
              variant="outlined"
              onClick={() => navigate('/reports')}
              style={{ borderColor: '#0a3d62', color: '#0a3d62' }}
            >
              All Reports
            </Button>
          </Box>
        </Box>
        
        <table border="1" style={{
          width: '100%',
          borderCollapse: 'collapse',
          marginBottom: '20px',
        }}>
          <tbody>
            <tr>
              <td style={{verticalAlign: 'top', padding: '20px'}}>
                <div style={{marginTop: '0.125in', marginBottom: '0.125in'}}>
                  <h1 style={{margin: 0, fontSize: '24px', fontWeight: 'bold', textAlign: 'center'}}>C-Encode</h1>
                  <p style={{margin: '5px 0 0 0', fontSize: '14px', textAlign: 'center'}}>9131 Keele St, Unit A4, Vaughan, ON L4K 0G7</p>
                </div>
                
                <div style={{marginBottom: '30px'}}>
                  <div style={{
                    backgroundColor: '#f5f5f5',
                    border: '1px solid #ddd',
                    padding: '8px',
                    marginBottom: '10px',
                    fontSize: '12px',
                    lineHeight: '1.2',
                  }}>
                    <div style={{display: 'grid', gridTemplateColumns: '100px 1fr', gap: '5px', alignItems: 'center', marginBottom: '8px'}}>
                      <div style={{fontWeight: 'bold'}}>Patient:</div>
                      <div>Aragorn Son of Arathorn</div>
                    </div>
                    <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px'}}>
                      <div style={{display: 'grid', gridTemplateColumns: '100px 1fr', gap: '5px', alignItems: 'center'}}>
                        <div style={{fontWeight: 'bold'}}>Birth Date:</div>
                        <div>1947-03-01</div>
                        <div style={{fontWeight: 'bold'}}>Height:</div>
                        <div>165 cm</div>
                        <div style={{fontWeight: 'bold'}}>Sex:</div>
                        <div>Female</div>
                      </div>
                      <div style={{display: 'grid', gridTemplateColumns: '100px 1fr', gap: '5px', alignItems: 'center'}}>
                        <div style={{fontWeight: 'bold'}}>Age:</div>
                        <div>76 years</div>
                        <div style={{fontWeight: 'bold'}}>Weight:</div>
                        <div>62.5 kg</div>
                        <div style={{fontWeight: 'bold'}}>Study Date:</div>
                        <div>2023-12-15</div>
                      </div>
                    </div>
                    <div style={{marginTop: '8px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px'}}>
                      <div style={{display: 'grid', gridTemplateColumns: '100px 1fr', gap: '5px', alignItems: 'center'}}>
                        <div style={{fontWeight: 'bold'}}>Ordered By:</div>
                        <div>Dr. Elrond of Rivendell</div>
                        <div style={{fontWeight: 'bold'}}>Reported By:</div>
                        <div>Dr. Galadriel of Lothlórien</div>
                      </div>
                      <div style={{display: 'grid', gridTemplateColumns: '100px 1fr', gap: '5px', alignItems: 'center'}}>
                        <div style={{fontWeight: 'bold'}}>CC:</div>
                        <div>Dr. Gandalf The White</div>
                        <div style={{fontWeight: 'bold'}}>Report Date:</div>
                        <div>2023-12-15</div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div style={{marginTop: '0.125in', marginBottom: '25px'}}>
                  
                  <div style={{marginTop: '15px', fontSize: '14px', lineHeight: '1.6'}}>
                    <h3 style={{fontSize: '16px', fontWeight: 'bold', marginBottom: '10px', color: '#0a3d62', marginTop: '20px'}}>REFERENCE EXAMINATIONS:</h3>
                    <p>Previous examination on December 01, 2020.</p>
                    
                    <h3 style={{fontSize: '16px', fontWeight: 'bold', marginBottom: '10px', color: '#0a3d62', marginTop: '20px'}}>TECHNIQUE:</h3>
                    <p>A repeat bone density study was obtained on this 76 year old FEMALE.</p>
                    
                    <h3 style={{fontSize: '16px', fontWeight: 'bold', marginBottom: '10px', color: '#0a3d62', marginTop: '20px'}}>FINDINGS:</h3>
                    <p>LUMBAR SPINE (L1-L3) = 1.003 g/cm². T-score = -1.4.</p>
                    <p>This value has INCREASED by 0.124 g/cm² (14.1%) compared to the previous.</p>
                    
                    <p>LEFT FEMORAL NECK = 0.888 g/cm². T-score = -1.1.</p>
                    
                    <p>LEFT TOTAL PROXIMAL FEMUR = 0.901 g/cm². T-score = -0.8.</p>
                    <p>This value has DECREASED by 0.070 g/cm² (-7.2%) compared to the previous.</p>
                    
                    <h3 style={{fontSize: '16px', fontWeight: 'bold', marginBottom: '10px', color: '#0a3d62', marginTop: '20px'}}>BONE MINERAL DENSITY:</h3>
                    <p>Low bone mass</p>
                    
                    <h3 style={{fontSize: '16px', fontWeight: 'bold', marginBottom: '10px', color: '#0a3d62', marginTop: '20px'}}>10 YEAR ABSOLUTE FRACTURE RISK:</h3>
                    <p>Moderate, 10-20%</p>
                    
                    <h3 style={{fontSize: '16px', fontWeight: 'bold', marginBottom: '10px', color: '#0a3d62', marginTop: '20px'}}>RISK MODIFIERS:</h3>
                    <p>None</p>
                    
                    <h3 style={{fontSize: '16px', fontWeight: 'bold', marginBottom: '10px', color: '#0a3d62', marginTop: '20px'}}>SUMMARY:</h3>
                    <p>This patient has LOW bone mass with MODERATE fracture risk.</p>
                    
                    <p>Lumbar Spine: Statistically SIGNIFICANT interval INCREASE.</p>
                    <p>Left Total Proximal Femur: Statistically SIGNIFICANT interval DECREASE.</p>
                    <p>Current management could be reassessed.</p>
                    
                    <p>Vertebra(e) has/have been excluded from analysis as the T-score(s) is/are at least one standard deviation greater than the T-score of the vertebra with the next highest value.</p>
                    
                    <p>Follow-up suggested in 1-3 years.</p>
                    
                    <p>In patients with moderate fracture risk, it would be appropriate to consider a lateral x-ray of the thoracic and lumbar spine from T4-L4 to assess for possible compression fractures. The presence of a compression fracture of more than 25% would place the patient into the HIGH RISK category for future fractures and could change management strategies.</p>
                    
                    <p>Consider pharmacologic therapy. Effective therapies are available in the form of bisphosphonates.</p>
                    
                    <p>Non-pharmacological and lifestyle measures are applicable to all patients. All patients should ensure an adequate intake of dietary calcium (1200 mg/d) and vitamin D (800-2000 IU daily).</p>
                    
                    <div><strong>LSC (least significant change) at C-Encode:</strong></div>
                    <p>Lumbar Spine - 0.031 gm/cm²</p>
                    <p>Total Hip - 0.019 gm/cm²</p>
                    
                    <div><strong>CAROC recommendations (2010)</strong></div>
                    <p>Adults aged 50 years and older:</p>
                    <p>T-score between -1 and -2.5 = low bone mass</p>
                    <p>T-score -2.5 or less = osteoporosis</p>
                    
                    <p>Fragility fractures of spine or hip or 2 fragility fractures elsewhere = high fracture risk regardless of T-score.</p>
                  </div>
                </div>
                
                <div style={{marginTop: '40px', textAlign: 'center', fontSize: '12px', color: '#666'}}>
                  <p>Report generated on: 2023-12-15</p>
                  <p>Page 1 of 1</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </Box>
    </div>
  );
};

export default Report2; 